<template>
  <div class="text-13 h-6 flex items-center">{{ item && item.type ? $t(`evaluate_editor.${item.type}`) : '' }}</div>
</template>

<script>
export default {
  name: 'ResponseOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    payload() {
      return this.item.payload;
    },
  },
};
</script>
